// extracted by mini-css-extract-plugin
export default {"giftPointBody":"ShopDeactivate_giftPointBody__aMNOB","okBtn":"ShopDeactivate_okBtn__p9Dzu","noBtn":"ShopDeactivate_noBtn__MJ6EF"};